/**
 * Builds a circuit-breaker `fallback` object that survives the round-trip through
 * @bonnet/fetch intact.
 *
 * @bonnet/fetch's CircuitBreakerManager only uses a fallback object as-is when
 * `fallback.body && fallback.ok` are BOTH truthy - otherwise it re-JSON.stringifies the
 * *entire* fallback object as the new body, double-encoding it (empirically confirmed:
 * without `ok`, the caller sees `{ body: '{"...":true}' }` instead of the parsed marker).
 *
 * Exported via `module.exports`, not ESM `export`, because `plugins/withKbbRedirect.js`
 * `require()`s this file directly - plugins/ and bonnet.config.js run as plain CommonJS
 * under `node` (no Next/webpack transpilation), so this file stays CommonJS to match them.
 * History: while the PR-env/prod Docker image ran Node 20, an `export` here crashed that
 * `require()` with `SyntaxError: Unexpected token 'export'` on boot and failed EB health
 * checks in every deployed environment (#2851). Dockerfile_aws now uses Node 24.
 */
function createErrorMarkerFallback(markerKey) {
    return { body: JSON.stringify({ [markerKey]: true }), ok: true };
}

/**
 * Checks whether a fetchJSON response is the circuit-breaker fallback produced by
 * createErrorMarkerFallback, as opposed to a genuine (if empty) successful response.
 */
function isErrorMarkerResponse(response, markerKey) {
    return Boolean(response && response[markerKey]);
}

module.exports = { createErrorMarkerFallback, isErrorMarkerResponse };
